// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".intimate-rule[data-v-3651601e]{width:100%;min-height:100vh;background:#f9f9fb}.intimate-rule .main[data-v-3651601e]{height:100%;padding:16px 20px;color:#666;line-height:24px;font-size:15px}.intimate-rule .main .titie1[data-v-3651601e],.intimate-rule .main .titie2[data-v-3651601e]{font-size:17px;color:#333;font-weight:700}.intimate-rule .main .text1[data-v-3651601e]{padding-left:14px}", ""]);
// Exports
module.exports = exports;
